import React from 'react';
import PropTypes from 'prop-types';
import { getMissingMessage } from '../../shared/utils/UtilsHelper';
import SizeDisplay from './SizeDisplay';
import Icon from 'Components/Icon';

function CardSpecs(props) {
    const {
        maxOccupancy, size, sizeUnit, className,
    } = props;

    // i18nLabel[bf.roomDetails.maxOccupancy]

    return (
        (maxOccupancy || (size && sizeUnit))
        && (
            <div className={`kbe-card-specs-wrapper text-muted ${className}`}>
                {
                    maxOccupancy ? <div className="kbe-card-spec kbe-card-spec-max-occupancy">
                        <Icon name="Users" className="kbe-card-spec-icon" />
                        {
                            getMissingMessage('bf.roomDetails.maxOccupancy', { maxOccupancy })
                        }
                    </div> : null
                }
                {
                    (size && sizeUnit)
                        ? (
                            <div className="kbe-card-spec kbe-card-spec-room-size">
                                <Icon name="Home" className="kbe-card-spec-icon" />
                                <span><SizeDisplay size={size} sizeUnit={sizeUnit} /></span>
                            </div>
                        ) : null
                }
            </div>
        )
    );
}

CardSpecs.defaultProps = {
    maxOccupancy : null,
    size         : null,
    sizeUnit     : null,
};

CardSpecs.propTypes = {
    maxOccupancy : PropTypes.number,
    size         : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    sizeUnit     : PropTypes.string,
    className    : PropTypes.string,
};

export default CardSpecs;
